import React from "react";
import {Image} from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import Media from 'react-media';


import "./BusinessCoverage.css";
import 'swiper/swiper.scss';

import business_coverage from "../../asset/images/business_coverage.webp";

SwiperCore.use([Autoplay]);

// 业务覆盖
class BusinessCoverage extends React.Component {
  render() {
    return (
      <div className="business">
        <Image src={business_coverage} className="business_ico" />
        <div className="business_cards">
        <Media query="(max-width: 449px)" render={() =>
          (
            <Swiper
            slidesPerView={1}
            // spaceBetween={}
            // slidesOffsetBefore={50}
            // breakpoints={{
            //   700:{
            //     slidesPerView: 1,
            //     spaceBetween: 2
            //   }
            // }}
              // spaceBetween={20}
              
              loop={true}
              autoplay={{
                delay: "1000"
              }}
              centeredSlides={true}
              onSwiper={
                (swiper)=>{
                  //鼠标悬浮暂停效果
                  swiper.$el[0].addEventListener('mouseover',()=>swiper.autoplay.stop());
                  //鼠标移开后继续自动滚屏效果
                  swiper.$el[0].addEventListener('mouseleave',()=>swiper.autoplay.start());
                }
              }
            >
              <SwiperSlide className="business_swiper">
                <div className="business_card_air business_card">
                  <span className="business_card_title">压缩空气系统</span>
                  <p>采取设备定制、优化控制、设备再优化、精细运维并结合工艺特点，大幅提升空压系统运行效率，降低能耗及成本支出</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_cole_hot business_card">
                  <span className="business_card_title">冷/热回收系统</span>
                  <p>利用自然冷源在冬季或过渡季节免费供冷，利用余热/废热提供免费供热</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_air_conditioning business_card">
                  <span className="business_card_title">中央空调优化控制</span>
                  <p>以中央计算机和PLC为硬件核心，以全局节能优化算法为软件核心，以变频控制为手段的群控系统解决方案</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_platform business_card">
                  <span className="business_card_title">能源管理及运维平台</span>
                  <p>为动力设施运营提供智慧能源管理服务，主要功能包括：在线故障诊断、负荷预测、预防性维护、能效分析、智慧KPI管理、自动报表等</p>
                </div>
                </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_steam business_card">
                  <span className="business_card_title">蒸汽系统</span>
                  <p>采取蒸汽梯级利用、余热回收、降低泄漏、整体规划等手段，全方位降低蒸汽运行费用</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_motor business_card">
                  <span className="business_card_title">电机系统（低压/高压）</span>
                  <p>根据工艺特点，根据实际需求的流量和扬程，增加变频智能控制功能，降低能耗</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_heat_pump business_card">
                  <span className="business_card_title">热泵热水系统</span>
                  <p>热泵取代传统燃油/燃气/电锅炉，利用峰谷电差或冷热联产进一步对系统优化设计，适用于热需求量大且热负荷比较稳定的工厂或园区</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_light business_card">
                  <span className="business_card_title">智能照明</span>
                  <p>利用高效节能光源替换现有传统光源，结合智能优化控制，大幅降低照明电耗和散失热量</p>
                </div>
              </SwiperSlide>
            </Swiper>
          )}
        />
          <Media query="(min-width: 450px) and (max-width: 899px)" render={() =>
          (
            <Swiper
            slidesPerView={2}
            // spaceBetween={}
            slidesOffsetBefore={50}
            // breakpoints={{
            //   700:{
            //     slidesPerView: 1,
            //     spaceBetween: 2
            //   }
            // }}
              // spaceBetween={20}
              
              loop={true}
              autoplay={{
                delay: "1000"
              }}
              centeredSlides={true}
              onSwiper={
                (swiper)=>{
                  //鼠标悬浮暂停效果
                  swiper.$el[0].addEventListener('mouseover',()=>swiper.autoplay.stop());
                  //鼠标移开后继续自动滚屏效果
                  swiper.$el[0].addEventListener('mouseleave',()=>swiper.autoplay.start());
                }
              }
            >
              <SwiperSlide className="business_swiper">
                <div className="business_card_air business_card">
                  <span className="business_card_title">压缩空气系统</span>
                  <p>采取设备定制、优化控制、设备再优化、精细运维并结合工艺特点，大幅提升空压系统运行效率，降低能耗及成本支出</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_cole_hot business_card">
                  <span className="business_card_title">冷/热回收系统</span>
                  <p>利用自然冷源在冬季或过渡季节免费供冷，利用余热/废热提供免费供热</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_air_conditioning business_card">
                  <span className="business_card_title">中央空调优化控制</span>
                  <p>以中央计算机和PLC为硬件核心，以全局节能优化算法为软件核心，以变频控制为手段的群控系统解决方案</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_platform business_card">
                  <span className="business_card_title">能源管理及运维平台</span>
                  <p>为动力设施运营提供智慧能源管理服务，主要功能包括：在线故障诊断、负荷预测、预防性维护、能效分析、智慧KPI管理、自动报表等</p>
                </div>
                </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_steam business_card">
                  <span className="business_card_title">蒸汽系统</span>
                  <p>采取蒸汽梯级利用、余热回收、降低泄漏、整体规划等手段，全方位降低蒸汽运行费用</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_motor business_card">
                  <span className="business_card_title">电机系统（低压/高压）</span>
                  <p>根据工艺特点，根据实际需求的流量和扬程，增加变频智能控制功能，降低能耗</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_heat_pump business_card">
                  <span className="business_card_title">热泵热水系统</span>
                  <p>热泵取代传统燃油/燃气/电锅炉，利用峰谷电差或冷热联产进一步对系统优化设计，适用于热需求量大且热负荷比较稳定的工厂或园区</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_light business_card">
                  <span className="business_card_title">智能照明</span>
                  <p>利用高效节能光源替换现有传统光源，结合智能优化控制，大幅降低照明电耗和散失热量</p>
                </div>
              </SwiperSlide>
            </Swiper>
          )}
        />
        <Media query="(min-width: 900px) and (max-width: 1499px)" render={() =>
          (
            <Swiper
            slidesPerView={3}
            // spaceBetween={}
            slidesOffsetBefore={60}
            // breakpoints={{
            //   700:{
            //     slidesPerView: 1,
            //     spaceBetween: 2
            //   }
            // }}
              // spaceBetween={20}
              
              loop={true}
              autoplay={{
                delay: "1000"
              }}
              centeredSlides={true}
              onSwiper={
                (swiper)=>{
                  //鼠标悬浮暂停效果
                  swiper.$el[0].addEventListener('mouseover',()=>swiper.autoplay.stop());
                  //鼠标移开后继续自动滚屏效果
                  swiper.$el[0].addEventListener('mouseleave',()=>swiper.autoplay.start());
                }
              }
            >
              <SwiperSlide className="business_swiper">
                <div className="business_card_air business_card">
                  <span className="business_card_title">压缩空气系统</span>
                  <p>采取设备定制、优化控制、设备再优化、精细运维并结合工艺特点，大幅提升空压系统运行效率，降低能耗及成本支出</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_cole_hot business_card">
                  <span className="business_card_title">冷/热回收系统</span>
                  <p>利用自然冷源在冬季或过渡季节免费供冷，利用余热/废热提供免费供热</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_air_conditioning business_card">
                  <span className="business_card_title">中央空调优化控制</span>
                  <p>以中央计算机和PLC为硬件核心，以全局节能优化算法为软件核心，以变频控制为手段的群控系统解决方案</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_platform business_card">
                  <span className="business_card_title">能源管理及运维平台</span>
                  <p>为动力设施运营提供智慧能源管理服务，主要功能包括：在线故障诊断、负荷预测、预防性维护、能效分析、智慧KPI管理、自动报表等</p>
                </div>
                </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_steam business_card">
                  <span className="business_card_title">蒸汽系统</span>
                  <p>采取蒸汽梯级利用、余热回收、降低泄漏、整体规划等手段，全方位降低蒸汽运行费用</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_motor business_card">
                  <span className="business_card_title">电机系统（低压/高压）</span>
                  <p>根据工艺特点，根据实际需求的流量和扬程，增加变频智能控制功能，降低能耗</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_heat_pump business_card">
                  <span className="business_card_title">热泵热水系统</span>
                  <p>热泵取代传统燃油/燃气/电锅炉，利用峰谷电差或冷热联产进一步对系统优化设计，适用于热需求量大且热负荷比较稳定的工厂或园区</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper">
                <div className="business_card_light business_card">
                  <span className="business_card_title">智能照明</span>
                  <p>利用高效节能光源替换现有传统光源，结合智能优化控制，大幅降低照明电耗和散失热量</p>
                </div>
              </SwiperSlide>
            </Swiper>
          )}
        />
        <Media query="(min-width: 1500px)" render={() =>
          (
            <Swiper
              // spaceBetween={20}
              slidesPerView={5}
              loop={true}
              autoplay={{
                delay: "1000"
              }}

              slidesOffsetBefore={60}

              onSwiper={
                (swiper)=>{
                  //鼠标悬浮暂停效果
                  swiper.$el[0].addEventListener('mouseover',()=>swiper.autoplay.stop());
                  //鼠标移开后继续自动滚屏效果
                  swiper.$el[0].addEventListener('mouseleave',()=>swiper.autoplay.start());
                }
              }
            >
              <SwiperSlide className="business_swiper" virtualIndex="0">
                <div className="business_card_air business_card">
                  <span className="business_card_title">压缩空气系统</span>
                  <p>采取设备定制、优化控制、设备再优化、精细运维并结合工艺特点，大幅提升空压系统运行效率，降低能耗及成本支出</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper" virtualIndex="1">
                <div className="business_card_cole_hot business_card">
                  <span className="business_card_title">冷/热回收系统</span>
                  <p>利用自然冷源在冬季或过渡季节免费供冷，利用余热/废热提供免费供热</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper" virtualIndex="2">
                <div className="business_card_air_conditioning business_card">
                  <span className="business_card_title">中央空调优化控制</span>
                  <p>以中央计算机和PLC为硬件核心，以全局节能优化算法为软件核心，以变频控制为手段的群控系统解决方案</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper" virtualIndex="3">
                <div className="business_card_platform business_card">
                  <span className="business_card_title">能源管理及运维平台</span>
                  <p>为动力设施运营提供智慧能源管理服务，主要功能包括：在线故障诊断、负荷预测、预防性维护、能效分析、智慧KPI管理、自动报表等</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper" virtualIndex="4">
                <div className="business_card_steam business_card">
                  <span className="business_card_title">蒸汽系统</span>
                  <p>采取蒸汽梯级利用、余热回收、降低泄漏、整体规划等手段，全方位降低蒸汽运行费用</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper" virtualIndex="5">
                <div className="business_card_motor business_card">
                  <span className="business_card_title">电机系统（低压/高压）</span>
                  <p>根据工艺特点，根据实际需求的流量和扬程，增加变频智能控制功能，降低能耗</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper" virtualIndex="6">
                <div className="business_card_heat_pump business_card">
                  <span className="business_card_title">热泵热水系统</span>
                  <p>热泵取代传统燃油/燃气/电锅炉，利用峰谷电差或冷热联产进一步对系统优化设计，适用于热需求量大且热负荷比较稳定的工厂或园区</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="business_swiper" virtualIndex="7">
                <div className="business_card_light business_card">
                  <span className="business_card_title">智能照明</span>
                  <p>利用高效节能光源替换现有传统光源，结合智能优化控制，大幅降低照明电耗和散失热量</p>
                </div>
              </SwiperSlide>
            </Swiper>
          )}
        />
        
        </div>
      </div>
    )
  }
}

export default BusinessCoverage
